export type PlannedSetExercise={slug:string;sets:number;reps:string;rir_target:number};
export type CompletedSet={slug:string;set_no:number;weight_kg:number|null;reps:number|null;rir:number|null;set_kind?:'working'|'warmup'};
export type PreviousSet={set_no:number;weight_kg:number|null;reps:number|null;rir:number|null};

export function targetRepetitions(prescription:string):number{
  const match=prescription.match(/\d+/);
  return match?Math.max(1,Number(match[0])):1;
}

export function nextIncompleteExercise(exercises:PlannedSetExercise[],sets:CompletedSet[],fromIndex=0):number{
  if(!exercises.length)return 0;
  for(let offset=0;offset<exercises.length;offset++){
    const index=(Math.max(0,fromIndex)+offset)%exercises.length,exercise=exercises[index]!;
    const completed=new Set(sets.filter(set=>set.slug===exercise.slug&&(set.set_kind??'working')==='working').map(set=>set.set_no));
    if(Array.from({length:exercise.sets},(_,position)=>position+1).some(setNo=>!completed.has(setNo)))return index;
  }
  return Math.min(Math.max(0,fromIndex),exercises.length-1);
}

export function nextIncompleteSet(exercise:PlannedSetExercise,sets:CompletedSet[]):number|null{
  const completed=new Set(sets.filter(set=>set.slug===exercise.slug&&(set.set_kind??'working')==='working').map(set=>set.set_no));
  for(let setNo=1;setNo<=exercise.sets;setNo++)if(!completed.has(setNo))return setNo;
  return null;
}

export function suggestedSet(exercise:PlannedSetExercise,setNo:number,previous:PreviousSet[]=[]){
  const exact=previous.find(set=>set.set_no===setNo),fallback=previous.at(-1);
  return {weight_kg:exact?.weight_kg??fallback?.weight_kg??null,reps:targetRepetitions(exercise.reps),rir:exercise.rir_target??null};
}
